import React from 'react';
import { useChatbot } from '../../context/ChatbotContext';
import { ProductsTab } from '../../components/chatbot/tabs/ProductsTab';

const ChatbotProductsPage: React.FC = () => {
  const { account } = useChatbot();
  return <ProductsTab account={account} />;
};

export default ChatbotProductsPage;
